import _ from "lodash";
import { AccountingEntity } from "../../../entity/AccountingEntity";
import { AssistantHttpGateway } from "../../../gateway/AssistantHttpGateway";
import { registerCustomerRequest } from "../CustomerRequest/register-customer-request";
import { EmailSESService } from "../EmailSES/EmailSES";
import { Events } from "../Events/Events";
import requestContractDialogTemplate from "../../../shared/dialogs/request-contract/request-contract-dialog.html";
import { requesterFromUser } from "../../../shared/email/internal-email-layout";
import { TemplateRequestContract } from "./template-request-contract";

export class ContractPlansService {
    Events = new Events();
    AssistantHttpGateway = new AssistantHttpGateway();

    constructor({ DSNDialogService, User } = {}) {
        this.DSNDialogService = DSNDialogService;
        this.AccountingEntity = {};
        this.User = User;
    }

    setAccountingEntity(accountingData) {
        this.AccountingEntity = new AccountingEntity(
            accountingData,
            accountingData._id
        );
    }

    requestContract($event) {
        this.Events.send(`Plano.solicitar.upgrade`);

        this.sendEmail();
        this.registerRequest();

        this.DSNDialogService.custom({
            targetEvent: $event,
            controller: "RequestContractDialogCtrl",
            controllerAs: "$ctrl",
            clickOutsideToClose: true,
            locals: {
                width: "450px",
                templateHtml: requestContractDialogTemplate
            },
            after: {}
        });
    }

    // Sem a trava de produção do e-mail: o kanban do sandbox também existe, e é lá que o
    // registro é testado. Fire-and-forget, nunca rejeita (ver registerCustomerRequest).
    registerRequest() {
        return registerCustomerRequest(this.AssistantHttpGateway, {
            tipo: "mudanca-plano",
            accountingId: _.get(this.AccountingEntity, "props._id")
        });
    }

    sendEmail() {
        if (publicSettings.environment != "production") return;

        const templateString = this.templateEmail({
            plan: _.get(this.AccountingEntity, "props.contract"),
            hubspotId: _.get(this.AccountingEntity, "props.hubspot._id"),
            accountingCode: _.get(
                this.AccountingEntity,
                "props.superLogica._id"
            ),
            requester: requesterFromUser(this.User)
        });

        const senderEmail = new EmailSESService();

        const subject = `Quero mudar de plano: ${_.get(
            this.AccountingEntity,
            "props.name"
        )}`;

        senderEmail.sendBulk({
            subject: subject,
            to: [
                { name: "Hadna Esteves", email: "hadna.esteves@nucont.com" },
                {
                    name: "Giovanni Gontijo",
                    email: "giovanni.gontijo@nucont.com"
                },
                {
                    name: "Matheus Queiroga",
                    email: "matheus.queiroga@nucont.com"
                },
                {
                    name: "Fernando Pinheiro",
                    email: "fernando.pinheiro@nucont.com"
                },
                { name: "Thaina Souza", email: "thaina.souza@nucont.com" },
                { name: "Vinicius", email: "vinicius@nucont.com" }
            ],
            from: {
                name: "Nucont",
                email: "nanda@nucont.com"
            },
            bodyOptions: {
                reference: "ComunicacaoInterna",
                defaultParams: {
                    subject: subject,
                    templateString
                }
            }
        });
    }
    templateEmail({ plan, hubspotId, accountingCode, requester }) {
        return TemplateRequestContract({
            accounting: {
                name: _.get(this.AccountingEntity, "props.name"),
                superLogicaId: accountingCode,
                hubspotId,
                contract: plan,
                integrationsHealth: _.get(
                    this.AccountingEntity,
                    "props.integrationsHealth"
                )
            },
            requester
        });
    }
}
